import { Component, OnDestroy, OnInit } from '@angular/core';
import { SaveService } from './save.service';
import { Observable, Subscription, filter } from 'rxjs';
import { AuthService } from 'src/app/auth.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';

@Component({
  standalone: false,
  selector: 'app-save-button',
  template: `
    <button *ngIf="hasWriteRole" mat-icon-button (click)="save()">
        <mat-icon *ngIf="(isLoading$ | async) === false else loading">save</mat-icon>
    </button>
        <ng-template #loading>
          <div class="loader"><mat-spinner [diameter]="30"></mat-spinner></div>
        </ng-template>
  `,
  styles: [
    `
    .loader ::ng-deep .mat-progress-spinner circle, .mat-spinner circle {
    stroke: white;
}
    `
  ]
})
export class SaveButtonComponent implements OnInit, OnDestroy {

  isLoading$!: Observable<boolean>;
  hasWriteRole = false;
  private msalSubscription!: Subscription;

  constructor(
    private saveService: SaveService,
    private authService: AuthService,
    private msalBroadcastService: MsalBroadcastService
  ) { }

  ngOnInit(): void {
    this.isLoading$ = this.saveService.isLoading$;
    this.msalSubscription = this.msalBroadcastService.inProgress$
      .pipe(filter(status => status === InteractionStatus.None))
      .subscribe(() => {
        this.hasWriteRole = this.authService.hasWriteRole();
      });
  }

  ngOnDestroy(): void {
    this.msalSubscription?.unsubscribe();
  }

  save() {
    this.saveService.sendSignal();
  }
}
